import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { dynamicBaseQuery } from '~/api/common/dynamicBaseQuery';
import { AvailableAction } from '~/api/models/availableAction';
import { Campaign } from '~/api/models/campaign';
import { CampaignSearchCriteria } from '~/api/models/campaignSearchCriteria';

export const campaignsServiceApi = createApi({
    reducerPath: 'campaignApi',
    baseQuery: dynamicBaseQuery,
    tagTypes: ['Campaign'],
    endpoints: (builder) => ({
        listCampaigns: builder.query<Campaign[], CampaignSearchCriteria>({
            query: (params) => ({
                url: `/v1/admin/campaign`,
                method: 'GET',
                params
            }),
            providesTags: ['Campaign'],
        }),
        createCampaign: builder.mutation<Campaign, Campaign>({
            query: (data) => {
                return {
                    url: '/v1/admin/campaign',
                    method: 'POST',
                    body: data,
                };
            },
        }),
        editCampaign: builder.mutation<Campaign, Campaign>({
            query: (data) => {
                const { id, ...body } = data;
                return {
                    url: `/v1/admin/campaign/${data.id}`,
                    method: 'PUT',
                    body: body,
                };
            },
            invalidatesTags: ['Campaign'],
        }),
        getCampaignById: builder.query<Campaign, { id?: number }>({
            query: (data) => {
                return {
                    url: `/v1/admin/campaign/${data.id}`,
                    method: 'get',
                };
            },
        }),
        deleteCampaign: builder.mutation<void, number>({
            query: (id) => ({
                url: `/v1/admin/campaign/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Campaign'],
        }),
        getCampaignAvailableActions: builder.query<AvailableAction[], number>({
            query: (id) => ({
                url: `/v1/admin/campaign/${id}/available-actions`,
                method: 'GET',
            }),
            providesTags: ['Campaign'],
        }),

    })
});
export const {
    useListCampaignsQuery,
    useCreateCampaignMutation,
    useEditCampaignMutation,
    useLazyGetCampaignByIdQuery,
    useGetCampaignAvailableActionsQuery,
} = campaignsServiceApi;

